/**
 * Script de arranque (IIFE): vive *fuera* del módulo root-config.
 * No empaqueta el JSON compartido completo: `single-spa` viene de DefinePlugin (`__SINGLE_SPA_SYSTEMJS_URL__`).
 * Ver `utils/register-shared-importmap.ts`.
 */

import { registerSingleSpaImportMap } from './utils/register-single-spa-importmap'
import {
  addSystemImportMap,
  getSystemWithImportMaps,
  prepareSystemImportMaps,
} from './utils/system-importmap-helpers'

declare const __ROOT_CONFIG_MODULE_FULL_URL__: string
declare const __GLOBAL_IMPORTMAP_BASE_URL__: string

/** fetch + addImportMap, o script type=systemjs-importmap si falla (p. ej. CORS). */
async function installImportMapFromUrl(mapUrl: string): Promise<void> {
  const sys = getSystemWithImportMaps()

  try {
    const res = await fetch(mapUrl, { credentials: 'omit', mode: 'cors' })
    if (!res.ok) throw new Error(`HTTP ${res.status}`)
    const data = (await res.json()) as Record<string, unknown>
    sys.addImportMap(data, mapUrl)
  } catch {
    await new Promise<void>((resolve, reject) => {
      const script = document.createElement('script')
      script.type = 'systemjs-importmap'
      script.src = mapUrl
      script.onload = () => resolve()
      script.onerror = () => reject(new Error(`No se pudo cargar import map: ${mapUrl}`))
      document.head.appendChild(script)
    })
    await sys.prepareImport(true)
  }
}

async function installBootstrapImportMaps(): Promise<void> {
  registerSingleSpaImportMap()

  addSystemImportMap({
    imports: {
      '@ubits-mf/root-config': __ROOT_CONFIG_MODULE_FULL_URL__,
    },
  })

  const base = (__GLOBAL_IMPORTMAP_BASE_URL__ || '').replace(/\/$/, '')
  if (base) {
    try {
      await installImportMapFromUrl(`${base}/import_map_manager.json`)
    } catch (err) {
      console.warn(
        '[ubits-mf/bootstrap] import_map_manager no disponible; continúa solo con root-config.',
        err
      )
    }
  }

  await prepareSystemImportMaps()
}

async function run(): Promise<void> {
  await installBootstrapImportMaps()
  await getSystemWithImportMaps().import('@ubits-mf/root-config')
}

void run()
